import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "justify-center flex-row"
}
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = {
  key: 0,
  class: "col w-full"
}

import { ref, watch, onMounted, computed } from 'vue';
import EsContentCalendar from '@/components/calendar/esContentCalendar.vue';
import { CalendarView } from '@/models/calendar.model';
import EsTemplateEvent from '@/components/calendar/esTemplateEvent.vue';
import { ItemSelect, ItemTag } from '@/models/share.model';
import EsCalendarHeader from '@/components/calendar/esCalendarHeader.vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useI18n } from 'vue-i18n';
import { DurationInput } from '@fullcalendar/core';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esDailyCalendar',
  props: {
    selectedDate: {},
    getEventByDay: {},
    itemTags: {},
    refresh: { type: Boolean },
    customRef: {},
    calcHeight: {},
    smallDisplay: { type: Boolean },
    cssEventClass: {},
    displayNowIndicator: { type: Boolean },
    getBusinessHours: { type: Boolean },
    displayCreateAppointment: { type: Boolean, default: false },
    patient: { default: null },
    displayInitial: { type: Boolean, default: false },
    getAppointmentmentTypes: { type: Boolean, default: true },
    doctors: {},
    startTime: {},
    endTime: {},
    nbCalendar: { default: 4 },
    scroll: {},
    isSetting: { type: Boolean },
    selectedDoctorAppoitmentTypes: {},
    changeDate: {},
    changeAgendaType: {},
    changeAppointmentType: {},
    changePatient: {},
    changeDoctor: {},
    changeDoctorList: {},
    eventDurationEditable: { type: Boolean },
    droppable: { type: Boolean },
    lastSelectedDoctorId: { default: undefined }
  },
  emits: ['openAddForm', 'refreshed', 'eventClick', 'selectAppointmentType', 'navigationChanged', 'refreshCalendar', 'openUpdateEvent', 'exposeApi', 'patientTagClick', 'updateEvent'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const currentEntryStore = useCurrentEntryStore();
const { t } = useI18n();

const emits = __emit;
const start = ref<number>(0);
const end = ref<number>(props.nbCalendar);
const itemTagPaginated = ref<ItemTag[]>();
const currentPage = ref<number>(1);

const unselectAppointmentType = ref<boolean>(false);

const nbAllPages = computed(() => Math.ceil(props.itemTags.length/props.nbCalendar));

const paginatedData = () => {
    itemTagPaginated.value = props.itemTags.slice(start.value, end.value);
    emits('navigationChanged');
}

const goRight = () => {
    if (end.value < props.itemTags.length) {
        start.value += props.nbCalendar;
        end.value += props.nbCalendar;
        currentPage.value ++;
        paginatedData();
    }
}

const goLeft = () => {
    if (start.value >= props.nbCalendar) {
        start.value -= props.nbCalendar;
        end.value -= props.nbCalendar;
        currentPage.value --;
        paginatedData();
    }
}

const selectAppointmentType = (data: { appointmentType: ItemTag, doctor: ItemTag }) => {
    if (props.patient) {
        if(data){
            emits('selectAppointmentType', { appointmentType: data.appointmentType, doctorId: data.doctor.id });
        }
    } else {
       emits('selectAppointmentType', { appointmentType: null, doctorId:  data?.doctor ? data.doctor.id : null });
    }
}

const getPatient = (): ItemTag[] => {
  return [{
    id: props.patient.id,
    label: props.patient.label,
    opened: false,
    selected: false
  }]
}

const patientTagClick = async () => {
    await currentEntryStore.setCurrentPatientCalendar(null);
    emits('patientTagClick', null);
}

async function accessPatient() {
  const patientId = props.patient.id;
  currentEntryStore.openPatientModal("appointments");
  await currentEntryStore.setModalPatient(patientId);
}

const setUnselectVariable = (newValue: boolean) => {
    unselectAppointmentType.value = newValue;
}

const getCss = () => {
    return props.cssEventClass + ' truncate-patient-name-view-day';
}

const updateEvent = (data: {id: string, start: string, end: string, selectedAppointmentType: ItemTag}, item: ItemTag) => {
    data.selectedAppointmentType = item;
    emits('updateEvent', data);
}

onMounted(() => {
    paginatedData();
});

watch(
    () => props.itemTags,
    () => {
        if (props.lastSelectedDoctorId) {
            const indexOfLastSelectedDoctor = props.itemTags.findIndex((itemTag) => itemTag.id === props.lastSelectedDoctorId);

            while(indexOfLastSelectedDoctor >=  end.value) {
                start.value += props.nbCalendar;
                end.value += props.nbCalendar;
                currentPage.value++;
            }

           while(indexOfLastSelectedDoctor <  start.value && start.value !== 0) {
                start.value -= props.nbCalendar;
                end.value -= props.nbCalendar;
                currentPage.value--;
            }
        } else {
            start.value = 0;
            end.value = props.nbCalendar;
            currentPage.value = 1;
        }
        
        paginatedData();
    }
);

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.displayCreateAppointment && _ctx.patient)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_text_item, {
            class: "pad-m",
            style: {"padding-right":"0.2rem"},
            txt: _unref(t)('calendar.header.appointment')
          }, null, 8, ["txt"]),
          _createVNode(_component_buttonGroup, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (accessPatient()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: getPatient()[0].label
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_es_button_icon, {
            class: "mbottom-01 psides-05",
            icon: "xmark",
            folder: "shareIcons",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (patientTagClick())),
            styles: "img-grey"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.itemTags.length > props.nbCalendar)
        ? (_openBlock(), _createBlock(_component_es_button_icon, {
            key: 0,
            icon: "chevron-left",
            folder: "navigationIcons",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (goLeft())),
            disabled: start.value === 0,
            styles: "img-primary item-xl"
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemTagPaginated.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["col", _ctx.itemTags.length > props.nbCalendar && _ctx.itemTags.length < end.value && !_ctx.isSetting ? 'calendar-width' : 'w-full']),
          key: index
        }, [
          (item.selected === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(EsCalendarHeader, {
                  itemTag: item,
                  displayInitial: _ctx.displayInitial,
                  displayCreateAppointment: _ctx.displayCreateAppointment,
                  patient: _ctx.patient,
                  displayPatient: false,
                  selectedAppointmentType: _ctx.selectedDoctorAppoitmentTypes ? _ctx.selectedDoctorAppoitmentTypes[item.id] : null,
                  unselectAppointmentType: false,
                  onPatientTagClick: _cache[3] || (_cache[3] = ($event: any) => (patientTagClick())),
                  onSelectAppointmentType: _cache[4] || (_cache[4] = ($event: any) => (selectAppointmentType($event))),
                  onSetUnselectedAppointmentType: _cache[5] || (_cache[5] = ($event: any) => (setUnselectVariable($event))),
                  onRefreshCalendar: _cache[6] || (_cache[6] = ($event: any) => (emits('refreshCalendar')))
                }, null, 8, ["itemTag", "displayInitial", "displayCreateAppointment", "patient", "selectedAppointmentType"]),
                _createVNode(EsContentCalendar, {
                  class: "w-full",
                  doctorId: item.id,
                  doctorName: item.label,
                  displayDayHeaders: false,
                  calendarView: _unref(CalendarView).DAY,
                  selectedDate: _ctx.selectedDate ?? new Date(),
                  customRef: _ctx.customRef + '-' + item.id,
                  getEvents: _ctx.getEventByDay,
                  refresh: _ctx.refresh,
                  calcHeight: _ctx.calcHeight,
                  displayNowIndicator: _ctx.displayNowIndicator,
                  getBusinessHours: _ctx.getBusinessHours,
                  startTime: _ctx.startTime,
                  endTime: _ctx.endTime,
                  selectedAppointmentType: _ctx.selectedDoctorAppoitmentTypes ? _ctx.selectedDoctorAppoitmentTypes[item.id] : null,
                  scroll: _ctx.scroll,
                  isSetting: props.isSetting,
                  changeDate: props.changeDate,
                  changeAgendaType: _ctx.changeAgendaType,
                  changeAppointmentType: _ctx.changeAppointmentType,
                  changePatient: _ctx.changePatient,
                  changeDoctor: _ctx.changeDoctor,
                  changeDoctorList: _ctx.changeDoctorList,
                  eventDurationEditable: _ctx.eventDurationEditable,
                  droppable: _ctx.droppable,
                  onRefreshed: _cache[7] || (_cache[7] = ($event: any) => (emits('refreshed', false))),
                  onDateClick: ($event: any) => ( emits('openAddForm', {info: $event, item: item})),
                  onEventClick: ($event: any) => (emits('eventClick', {info: $event, item: item})),
                  onExposeApi: ($event: any) => (emits('exposeApi', {info: $event, item: item} )),
                  onUpdateEvent: ($event: any) => (updateEvent($event, item))
                }, {
                  eventContent: _withCtx((arg) => [
                    (arg.event.display !== 'background')
                      ? _withDirectives((_openBlock(), _createBlock(EsTemplateEvent, {
                          key: 0,
                          appointment: arg,
                          smallDisplay: _ctx.smallDisplay,
                          cssClass: getCss(),
                          selectedDoctor: item,
                          doctors: _ctx.doctors
                        }, null, 8, ["appointment", "smallDisplay", "cssClass", "selectedDoctor", "doctors"])), [
                          [_directive_tooltip, !props.isSetting ? { 
                                value: `<strong>${_unref(PersonService).formatHonorificAndName(arg.event.extendedProps?.gender, arg.event.extendedProps?.lastname, arg.event.extendedProps?.firstname) ?? ''}</strong><br>
                                        <span class='font-tooltip'>${arg.event.title ?? ''}</span><br>
                                        <span class='font-tooltip'>${_unref(t)(`common.appointment.status.${arg.event.extendedProps?.status ?? ''}`)}</span><br>
                                        <span class='font-tooltip'>${arg.event.extendedProps?.comment ?? ''}</span>`,
                                escape: false
                            } : null]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["doctorId", "doctorName", "calendarView", "selectedDate", "customRef", "getEvents", "refresh", "calcHeight", "displayNowIndicator", "getBusinessHours", "startTime", "endTime", "selectedAppointmentType", "scroll", "isSetting", "changeDate", "changeAgendaType", "changeAppointmentType", "changePatient", "changeDoctor", "changeDoctorList", "eventDurationEditable", "droppable", "onDateClick", "onEventClick", "onExposeApi", "onUpdateEvent"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      (props.itemTags.length > props.nbCalendar)
        ? (_openBlock(), _createBlock(_component_es_button_icon, {
            key: 1,
            disabled: currentPage.value === nbAllPages.value,
            icon: "chevron-right",
            folder: "navigationIcons",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (goRight())),
            styles: "img-primary item-xl"
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})